import { SelectOption } from "common/components/Select";
import { ContentStatusFilterValue } from "domain/constants";

export function contentStatusFilterValueLabel(
  value: ContentStatusFilterValue,
): string {
  switch (value) {
    case ContentStatusFilterValue.ALL:
      return "alle";
    case ContentStatusFilterValue.DRAFT:
      return "utkast";
    case ContentStatusFilterValue.PUBLISHED:
      return "publisert";
    case ContentStatusFilterValue.ARCHIVED:
      return "arkivert";
  }
}

export const contentStatusFilterValueToSelectOption = (
  contentStatusFilterValue: ContentStatusFilterValue,
): SelectOption => {
  return {
    key: contentStatusFilterValue.toString(),
    value: contentStatusFilterValue.toString(),
    label: contentStatusFilterValueLabel(contentStatusFilterValue),
  };
};
